//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import React from 'react';
import * as Sentry from '@sentry/react';
import styled from 'styled-components';
import { WarningOutlined } from '@ant-design/icons';


const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  text-align: center;
  font-family: Arial, sans-serif;
  background-color: #f8f9fa;
`;

const Title = styled.h1`
  font-size: 2.2rem;
  margin-bottom: 1rem;
  color: #dc3545;
`;

const Message = styled.p`
  font-size: 1.2rem;
  margin-bottom: 1.5rem;
  color: #6c757d;
`;

const RefreshButton = styled.button`
  padding: 0.5rem 1rem;
  font-size: 1rem;
  color: white;
  background-color: #007bff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #0056b3;
  }
`;

const WarningIcon = styled(WarningOutlined)`
  font-size: 4rem;
  color: #ffc107;
  margin-bottom: 1rem;
`;

// ErrorPage Component
const ErrorPage = ({ resetError }) => {
  const handleRefresh = () => {
    if(typeof resetError === 'function') {
      resetError();
    }
    window.location.reload();
  };

  return (
    <ErrorContainer>
      <WarningIcon />
      <Title>Oops! Something went wrong</Title>
      {/* <Message>Please refresh your page.</Message> */}
      <RefreshButton onClick={handleRefresh}>Refresh</RefreshButton>
    </ErrorContainer>
  );
};


const SentryWrap = ({ children }) => (
    <Sentry.ErrorBoundary fallback={({ error, componentStack, resetError }) => (
        // <React.Fragment>
        //     <div>This component has encountered an error. Don't worry, we are on it!</div>
        // </React.Fragment>
        <ErrorPage resetError={resetError}/>
    )}>
        {children}
    </Sentry.ErrorBoundary>
);

export default SentryWrap;